module.exports = __webpack_public_path__ + "static/media/mnzlBackground.fcf4fa20.jpg";